/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.DeregistrationController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { DeregistrationRequest } from '../models/deregistration-request';
import { DeregistrationResponse } from '../models/deregistration-response';

@Injectable()
export class DeregistrationApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }


    public deregistration(request: DeregistrationRequest, spinnerMessage: string = null): Observable<DeregistrationResponse> {
        return this.httpClient.post<DeregistrationResponse>(`/api/deregistration`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
